import type { Request } from 'express';
import { ssrBffGet } from '../../../bff-api/bff';
import { getSearchData } from '../../search/api/getSearchData';
import { BloomreachProductType } from '../../search/hooks/use-search';
import { convertURLParamsToSearchParams } from '../../search/utils/search-url-params-utils';
import type { SearchParams, SearchResult } from '../../search/hooks/use-search';
import type { CategoryResponse } from '../model/CategoryResponse';
import type { ContentAssetResponse } from '../model/ContentAssetResponse';
import type { RedirectResponse } from '../model/RedirectResponse';

export interface ContentInfo {
    response?: RedirectResponse | CategoryResponse;
    serverParams?: SearchParams;
    page?: {
        pages: SearchResult[];
        pageParams: number[];
    };
}

export function isCategoryInfo(contentInfo?: ContentInfo): contentInfo is CategoryInfo {
    return !!contentInfo && contentInfo.response?.type === 'CATEGORY';
}

export interface CategoryInfo {
    response?: CategoryResponse;
    serverParams?: SearchParams;
    page?: {
        pages: SearchResult[];
        pageParams: number[];
    };
}

export async function getContentData(
    path: string,
    search: string,
    req?: Partial<Request>,
): Promise<ContentInfo> {
    const response = await ssrBffGet<ContentAssetResponse | CategoryResponse>(
        `content/resolve${path}`,
    );
    if (response.type === 'CONTENT_ASSET') {
        return {
            response: {
                type: 'REDIRECT',
                urlMapping: response.urlMapping,
            },
        };
    }
    const params = convertURLParamsToSearchParams({
        urlParams: new URLSearchParams(search),
        productType: BloomreachProductType.hardgood,
    });
    const page = await getSearchData({ ...params, categoryId: path }, req);
    return {
        response,
        serverParams: { ...params, categoryId: path },
        page: page
            ? {
                  pages: [page],
                  pageParams: [page.page.page],
              }
            : undefined,
    };
}

export async function getSearchInitData(
    search: string,
    req?: Partial<Request>,
): Promise<ContentInfo> {
    const params = convertURLParamsToSearchParams({
        urlParams: new URLSearchParams(search),
        productType: BloomreachProductType.hardgood,
    });
    const page = await getSearchData(params, req);
    return {
        serverParams: params,
        page: page
            ? {
                  pages: [page],
                  pageParams: [page.page.page],
              }
            : undefined,
    };
}
